// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ch-b";
export var colorBlue = "_ch-8";
export var colorDot = "_ch-0";
export var colorDotLarge = "_ch-2";
export var colorDotSmall = "_ch-1";
export var colorGreen = "_ch-7";
export var colorGrey = "_ch-3";
export var colorOrange = "_ch-5";
export var colorPink = "_ch-a";
export var colorPurple = "_ch-9";
export var colorRed = "_ch-4";
export var colorYellow = "_ch-6";